import { Primitive } from './Primitive';
import { Type } from './Type';
export class Integer64Range extends Primitive {
    lowerBound;
    lowerInclusive;
    upperBound;
    upperInclusive;
    constructor(params) {
        super(Type.Integer64Range);
        this.lowerBound = params.lowerBound;
        this.lowerInclusive = params.lowerInclusive;
        this.upperBound = params.upperBound;
        this.upperInclusive = params.upperInclusive;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZWdlcjY0UmFuZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL0ludGVnZXI2NFJhbmdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxhQUFhLENBQUE7QUFDdkMsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFFBQVEsQ0FBQTtBQVM3QixNQUFNLE9BQU8sY0FBZSxTQUFRLFNBQVM7SUFDbEMsVUFBVSxDQUFRO0lBQ2xCLGNBQWMsQ0FBUztJQUN2QixVQUFVLENBQVE7SUFDbEIsY0FBYyxDQUFTO0lBRWhDLFlBQVksTUFBNEI7UUFDdEMsS0FBSyxDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsQ0FBQTtRQUMxQixJQUFJLENBQUMsVUFBVSxHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUE7UUFDbkMsSUFBSSxDQUFDLGNBQWMsR0FBRyxNQUFNLENBQUMsY0FBYyxDQUFBO1FBQzNDLElBQUksQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQTtRQUNuQyxJQUFJLENBQUMsY0FBYyxHQUFHLE1BQU0sQ0FBQyxjQUFjLENBQUE7SUFDN0MsQ0FBQztDQUNGIn0=